import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.date}
          onChange={(e, v) => actions.onChange(e, row.id, { date: v })}
          readOnly={fields.date.read_only || readOnly}
        />
      </TableCell>
      <TableCell>
        <TableControls.NumerInput
          value={row.order_amount}
          onChange={(e, v) => actions.onChange(e, row.id, { order_amount: v })}
          readOnly={fields.order_amount.read_only || readOnly}
          precision={2}
        />
      </TableCell>
      <TableCell>
        <TableControls.StringInput
          value={row.payment_notes}
          onChange={(e, v) => actions.onChange(e, row.id, { payment_notes: v })}
          readOnly={fields.payment_notes.read_only || readOnly}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    date: PropTypes.string,
    order_amount: PropTypes.number,
    payment_notes: PropTypes.string,
  }).isRequired,
  fields: PropTypes.shape({
    date: PropTypes.shape({ read_only: PropTypes.bool }),
    order_amount: PropTypes.shape({ read_only: PropTypes.bool }),
    payment_notes: PropTypes.shape({ read_only: PropTypes.bool }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
};

export default memo(Row);
